import {
    type CreateDriveRecordResponseType,
    type CreateDriveRecordRequestType
} from "./type";
import {
    request
} from "../request";

const CreateDriveRecord = async (params: CreateDriveRecordRequestType): Promise<CreateDriveRecordResponseType> => {
    return await request<CreateDriveRecordResponseType>("/drive/createDriveRecord", {
        body: JSON.stringify(params),
        method: "POST"
    });
};

export default CreateDriveRecord;
